import { Mark, mergeAttributes } from "@tiptap/core";
export interface ColorOptions {
  HTMLAttributes: Record<string, any>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    color: {
      /**
       * Set a text color mark
       */
      setTextColor: (attributes?: { color: string }) => ReturnType;
      /**
       * Toggle a text color mark
       */
      toggleTextColor: (attributes?: { color: string }) => ReturnType;
      /**
       * Unset a text color mark
       */
      unsetTextColor: () => ReturnType;
    };
  }
}

export const TextColor = Mark.create<ColorOptions>({
  name: "textColor",

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute("data-text-color") || element.className.includes("text-editor"),
        renderHTML: (attributes) => {
          if (!attributes.color) {
            return {};
          }

          return {
            "data-text-color": attributes.color,
            class: `${attributes.color}`,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addCommands() {
    return {
      setTextColor:
        (attributes) =>
        ({ commands }) => {
          return commands.setMark(this.name, attributes);
        },
      toggleTextColor:
        (attributes) =>
        ({ commands }) => {
          return commands.toggleMark(this.name, attributes);
        },
      unsetTextColor:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },

  addStorage() {
    return {
      markdown: {
        serialize: {
          // add empty serializers so any custom html is removed
          open: "",
          close: "",
        },
      },
    };
  },
});
